<div *ngIf="isShown" class="payment-loader">
    <img src="../../../../assets/payment-loader.svg" class="payment-loader-icon" alt="loader">
</div>
